<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Acknowledgments">Acknowledgements</a></p>
<p class="TOC1"><a href="#/Chapter01"><b>1. Brooklyn, “the Big Mistake” and Vitagraph Studios</b></a></p>
<p class="TOC2"><i>Brief overview of the history of the borough of Brooklyn and the Vitagraph studios (one of America’s first film studios), which began in Midwood in 1897.</i></p>
<p class="TOC1"><a href="#/Chapter02"><b>2. Brownstone Brooklyn</b></a></p>
<p class="TOC2"><i>The miles of lovely Brownstones that dot neighborhoods throughout the borough are featured in dozens of films. Pictures and details from homes from Park Slope to Brooklyn Heights, Bushwick and more.</i></p>
<p class="TOC1"><span href="#/Chapter03" title="Link target outside of Sample"><b>3. The Brooklyn Bridge and the Brooklyn Heights Promenade</b></span></p>
<p class="TOC2"><i>One of the most famous destinations in the world is the backdrop for dozens of films. Bring this book on your next walk over the East River.</i></p>
<p class="TOC1"><span href="#/Chapter04" title="Link target outside of Sample"><b>4. Coney Island, Baby!</b></span></p>
<p class="TOC2"><i>How the famous piers, beaches, amusement park rides and entertainment (from family-friendly to tawdry) have been the setting for numerous films for over 120 years and counting.</i></p>
<p class="TOC1"><span href="#/Chapter05" title="Link target outside of Sample"><b>5. Gritty Brooklyn: “How You Doin’?”</b></span></p>
<p class="TOC2"><i>Brooklyn used as the background for gritty, intense films from The Warriors to Clockers and more.</i></p>
<p class="TOC1"><span href="#/Chapter06" title="Link target outside of Sample"><b>6. Romantic Brooklyn: “When the Moon Hits Your Eye…”</b></span></p>
<p class="TOC2"><i>Moonstruck to Annie Hall, Brooklyn symbolizes new possibilities for love and a place to find your true self with films that melt your heart.</i></p>
<p class="TOC1"><span href="#/Chapter07" title="Link target outside of Sample"><b>7. Indies and Auteurs: “Please Baby, Please Baby, Please!”</b></span></p>
<p class="TOC2"><i>A look at talented independent creators and how their roots in Brooklyn play a part in their unique vision.</i></p>
<p class="TOC1"><span href="#/Chapter08" title="Link target outside of Sample"><b>8. Location Shooting in Brooklyn</b></span></p>
<p class="TOC2"><i>The actual process behind filming in Brooklyn: speaking to location managers, editors, extras, actors, directors and people who have crews in their homes.</i></p>
<p class="TOC1"><span href="#/Chapter09" title="Link target outside of Sample"><b>9. Brooklyn Movies by Neighborhood</b></span></p>
<p class="TOC2"><i>The various neighborhoods throughout Brooklyn and the movies associated with them.</i></p>
<p class="TOC1"><span href="#/Chapter10" title="Link target outside of Sample"><b>10. “Anyone Here from Brooklyn?”</b></span></p>
<p class="TOC2"><i>Famous Brooklyn natives (and those who claim it as home) who have created the diaspora of movies beloved around the world, from writing to acting to music and more.</i></p>
<p class="TOC1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Recommended" title="Link target outside of Sample">Recommended Documentaries</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?ea986092